import React from "react";
import { CircularProgress, Typography, Box } from "@mui/material";

const SystemUpdateRecovery = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(4px)", // Optional: adds a nice blur effect
      }}
    >
      <CircularProgress size={60} thickness={4} sx={{ mb: 4 }} />
      <Typography
        variant="h5"
        component="div"
        sx={{ fontWeight: "bold", mb: 1, color: "#333" }}
      >
        系統已更新
      </Typography>
      <Typography variant="body1" color="textSecondary">
        重新整理畫面中，請稍候...
      </Typography>
    </Box>
  );
};

export default SystemUpdateRecovery;
